import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { DarwinButton, DarwinFlex, DarwinRow } from 'components/darwin-ui';
import { ReloadOutlined, SettingOutlined } from '@ant-design/icons';
import styles from './ProcessMap.module.css';
import { ROUTES } from 'routes/routes';
import { ChangeStatusSelect } from './ChangeStatusSelect';

export const ActionButtonsBar = ({
  processMapStatus,
  processMapStatusValueRef,
  refetchCanvas,
}: {
  processMapStatus: string;
  processMapStatusValueRef: React.MutableRefObject<string>;
  refetchCanvas: () => void;
}) => {
  const navigate = useNavigate();
  const { id: processMapId } = useParams();

  return (
    <DarwinRow className={styles.reactFlowSidebarContainer}>
      <DarwinFlex align="center" vertical={false}>
        <ChangeStatusSelect
          processMapStatus={processMapStatus}
          processMapStatusValueRef={processMapStatusValueRef}
        />
        <div className={styles.verticalLine} />
        <DarwinButton
          shape="circle"
          className={styles.sidebarSettingButton}
          icon={<SettingOutlined className={styles.sidebarSettingIcon} />}
          onClick={() =>
            navigate(
              generatePath(ROUTES.PROCESSES.MAPS.MAP.CONFIG, {
                id: processMapId || '',
                list: null,
              })
            )
          }
        />
        <DarwinButton
          shape="circle"
          className={styles.sidebarSettingButton}
          icon={<ReloadOutlined className={styles.sidebarSettingIcon} />}
          onClick={refetchCanvas}
        />
      </DarwinFlex>
    </DarwinRow>
  );
};
